
<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-button type="primary" @click="show_add"> 新增 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table :data-source="lis" bordered :pagination="false" :scroll="{ y: scroll_y }">
        <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
          <a-table :data-source="record.features" bordered :pagination="false">
            <a-table-column key="title" width="300px" title="标题" data-index="title" />
            <a-table-column key="items" title="更新内容" data-index="items">
              <template slot-scope="text, record">
                <div v-html="record.items"></div>
              </template>
            </a-table-column>
          </a-table>
        </p>
        <a-table-column key="version" title="版本号" data-index="version" />
        <a-table-column key="date" title="发布日期" data-index="date" />
        <a-table-column title="操作" width="150px" key="action">
          <template slot-scope="text, record">
            <a-button size="small" type="primary" @click="edit(record)"> 编辑 </a-button>
            <a-button size="small" type="danger" @click="del(record)"> 删除 </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <!-- 新增/编辑 -->
    <a-modal :title="is" width="50%" :visible="is_show" @ok="handleOk" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk"> 保存 </a-button>
      </template>
      <a-form-model ref="ruleForm" :model="info" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row>
          <!-- <a-col :span="8">
            	<a-select allowClear v-model="info.type" placeholder="请选择" @change="getid">
							<a-select-option :key="index" v-for="(item, index) in typeList" :value="item.id">
								{{ item.type }}
							</a-select-option>
						</a-select>
          </a-col> -->
          <a-col :span="12">
            <a-form-model-item ref="version" label="版本号" prop="version">
              <a-input v-model="info.version" placeholder="请输入版本号" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item ref="date" label="发布日期" prop="date">
              <a-date-picker
                v-model="info.date"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                placeholder="选择日期"
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <div class="center">
            <div class="centerTop">
              <a-input
                placeholder="请输入标题:"
                v-model="info.title"
                allow-clear
                @change="onChange"
                style="height: 50px; border-radius: 0; outline: none"
              />
            </div>
            <div class="centerBottom">
              <div>请输入更新内容:</div>
              <div class="test_box" ref="feedback" v-html="info.items" @blur="blurBook($event)" contenteditable="true"></div>
              <!-- @blur="message = $event.target.innerText" -->
               <!-- <div class="test_box" ref="feedback" @blur="info.items = $event.target.innerText" contenteditable="true"></div> -->
              <!-- <div v-model="info.items" contenteditable="true" class="test_box">

              </div> -->
              <!-- <a-textarea allow-clear placeholder="请输入更新内容" v-model="info.items" :rows="20" /> -->
            </div>
          </div>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  // version_get_list,
  //  version_add,
  // version_update,
  // version_del ,
  versionAdd,
  versionList,
  versionEdit,
  versionDelete,
} from '@/api/system'
export default {
  data() {
    return {
      type: '',
      lis: [],
      scroll_y: 150,
      is_show: false,
      is: '',
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        version: [{ required: true, message: '请输入版本', trigger: 'change' }],
        date: [{ required: true, message: '请选择日期', trigger: 'change' }],
      },
      typeIndex: undefined,
      info: {
        type: '',
        _id: undefined,
        version: '',
        date: '',
        title: '',
        items: '',
        features: [
          {
            title: '',
            cs: [
              {
                val: '',
              },
            ],
          },
        ],
      },
    }
  },
  mounted() {
    // this.get_lis()
    this.$nextTick(() => {
      // this.get_lis()
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() + 500
      }, 1000)
    })
  },
  methods: {
    //文本内容
    blurBook(e){
      console.log(e.target.innerText, 'e.target.innerText==========================') 
      this.info.items = e.target.innerText

    },
    //获取列表
    get_lis(data) {
      this.type = data
      console.log( this.type, ' this.type=====================')
      // version_get_list
      this.$nextTick(() => {
        versionList({
          type:  this.type,
        }).then((res) => {
          res.data.forEach((item) => {
            Object.assign(item, {
              features: [],
            })
            item.features.push({
              items: item.items,
              title: item.title,
            })
            // this.info.items =  this.info.items.replace(/\n|\r\n/g, ";")
            // item['items'] = item['items'].join('<br>')
            //  var reg = /[;；]/g;
            item.features[0].items = item.features[0].items.replace(/\n/g, '<br />')
            // var reg = /[;；]/g;
            //  item.features[0].items.replace(reg,/\n|\r\n/g )
          })
          this.lis = res.data
          console.log(res.data, 'res.data================')
          console.log(this.lis, 'this.lis=================')
        })
      })
    },
    //弹出框
    show_add() {
      this.typeIndex = 0
      this.is = '新增'
      this.info = {
        _id: undefined,
        version: '',
        date: '',
        title: '',
        items: '',
        features: [
          {
            title: '',
            cs: [
              {
                val: '',
              },
            ],
          },
        ],
      }
      this.is_show = true
    },
    //取消新增
    handleCancel() {
      this.$refs.ruleForm.resetFields()
      this.info = {
        version: '',
        date: '',
        title: '',
        items: '',
      }
      this.is_show = false
    },
    //增加条数
    add_t(index) {
      this.info.features[index].cs.push({
        val: '',
      })
      this.$forceUpdate()
    },
    //删除某条
    del_t(idx, i) {
      this.info.features[idx].cs.splice(i, 1)
      this.$forceUpdate()
    },
    //增加内容
    add_f() {
      this.info.features.push({
        title: '',
        cs: [
          {
            val: '',
          },
        ],
      })
    },
    //删除内容
    // del(record) {

    //   this.info.features.splice(idx, 1)
    // },
    //点击编辑
    edit(rult) {
      this.typeIndex = 1
      console.log(rult, 'rult=============================')
      var row = JSON.parse(JSON.stringify(rult))
       row.items = row.items.replace(/\n/g, '<br />');

      this.info = row
      this.is = '修改'
      this.is_show = true
    },
    // 提交
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.info.title.trim() == '') {
            this.$message.warning('标题为必填内容')
          } else if (this.info.items.trim() == '') {
            this.$message.warning('更新内容为必填内容')
          } else {
            if (this.typeIndex == 0) {
              // this.info.items =  this.info.items.replace(/\n|\r\n/g, ";")
              // item['items'] = item['items'].join('<br>')
              console.log(this.info.items, 'this.info.items=================')
              versionAdd({
                // id: 1,
                version: this.info.version,
                title: this.info.title,
                items: this.info.items.trim(),
                date: this.info.date,
                type: this.type,
              }).then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.msg)
                  this.info = {}
                  this.info.items = ''
                  this.get_lis(this.type)
                  this.is_show = false
                }
                console.log(res, 'res=======================')
              })
            } else if (this.typeIndex == 1) {
              
              Object.assign(this.info, {
                type: this.type
              })
              versionEdit(this.info).then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.msg)
                  this.info = {}
                  this.get_lis(this.type)
                  this.is_show = false
                }
                console.log(res, 'res=============')
              })
            }
          }
        }
      })

      // var _this = this
      // this.$refs.ruleForm.validate((valid) => {
      //   if (valid) {
      //     var lis = this.info.features
      //     lis.forEach((item) => {
      //       var cs = item.cs
      //       item['items'] = []
      //       cs.forEach((em) => {
      //         item['items'].push(em.val)
      //       })
      //       item['items'] = item['items'].join('<br>')
      //       delete item.cs
      //     })
      //     if (this.is == '新增') {
      //       version_add({
      //         data: this.info,
      //       }).then((res) => {
      //         if (res.code != 200) {
      //           this.$message.error(res.msg)
      //           return
      //         }
      //         this.$message.success('保存成功')
      //         this.handleCancel()
      //         this.get_lis()
      //       })
      //     } else {
      //       let id=this.info._id;
      //       delete this.info._id;
      //       version_update({ _id:id,data: this.info }).then((res) => {
      //         if (res.code != 200) {
      //           this.$message.error(res.msg)
      //           return
      //         }
      //         this.$message.success('保存成功')
      //         this.handleCancel()
      //         this.get_lis()
      //       })
      //     }
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
    },
    //删除
    del(row) {
      var _this = this
      this.$confirm({
        title: '确认删除此记录吗?',
        onOk() {
          versionDelete({
            id: row.id,
          }).then((res) => {
            if (res.code == 200) {
              _this.$message.success(res.msg)
              _this.get_lis(_this.type)
            } else {
              _this.$message.error(res.msg)
            }

            console.log(res, 'res==================')
          })
        },
        onCancel() {
          console.log('Cancel')
        },
        class: 'test',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.center {
  border: 1px solid #ccc;
  // .ant-input {
  //     border: 0 !important
  // }
  .centerTop {
    border-bottom: 1px solid #ccc;
    /deep/.ant-input-affix-wrapper .ant-input {
      border: 0 !important;
    }
  }
  .centerBottom {
      padding: 10px;
      font-size: 18px;
      color: rgb(177, 177, 177);
    /deep/.ant-input-affix-wrapper .ant-input {
      border: 0 !important;
    }
    textarea {
    
      margin: -1px 0;

      border: 0;
      border-radius: 0;
      resize: none;
    }
  }
  .test_box {
    // height: 100%;
    width: 100%;
    // width: 400px; 
    min-height: 300px; 
    max-height: 700px;
    margin-top: 10px;
    resize: none;
    border: 1px solid #ccc;
    color: rgb(47, 47, 47);
					// width: calc(100% - 60px);
					// float: left;
					outline: none;
					line-height: 20px;
					height: auto;
					// min-height: 40px;
					// max-height: 70px;
					overflow-y: scroll;
					padding-left: 5px;
					box-sizing: border-box;

					&::-webkit-scrollbar {
						width: 3px;
					}
    // _height: 120px; 
    // margin-left: auto; 
    // margin-right: auto; 
    // padding: 3px; 
    // outline: 0; 
    // border: 1px solid #a0b3d6; 
    // font-size: 12px; 
    // word-wrap: break-word;
    // overflow-x: hidden;
    // overflow-y: auto;
    // _overflow-y: visible;
}
}
</style>
